import { AnyModel, isModel, getSnapshot } from 'mobx-keystone'
import inflection from 'inflection'
import { getApiUri, getResourceName } from './helpers'
import { ApiResource } from './deserialize'
import { mapValues, each, omit } from 'lodash'
import { AnyApiModel } from './model/ApiModel'

// Recursively remove mobx-keystone internal properties from a snapshot
function cleanSnapshot(obj: any): any {
	if (obj === null || obj === undefined) return obj
	if (Array.isArray(obj)) return obj.map(cleanSnapshot)
	if (typeof obj === 'object') {
		const cleaned: any = {}
		for (const key in obj) {
			if (key !== '$modelType' && key !== '$modelId') {
				cleaned[key] = cleanSnapshot(obj[key])
			}
		}
		return cleaned
	}
	return obj
}

export function serializeModel(model: AnyApiModel, attributes?: { [key: string]: any }): ApiResource {
	// Get attributes
	const attr = attributes ? { ...attributes } : { ...model.$ }

	// Id is not part of that
	const id = attr.id
	if (attr.id !== undefined) delete attr.id

	// Created/updated at's we don't do.
	if (attr.created_at !== undefined) delete attr.created_at
	if (attr.updated_at !== undefined) delete attr.updated_at

	// Check relations
	const config = model.apiConfig()
	if (config.relationships) {
		// For now, just delete the values
		config.relationships.forEach(rel => {
			if (attr[rel.name] !== undefined) delete attr[rel.name]
		})
	}

	// Get type
	const resourceName = getResourceName(model)

	// Look at nested models
	each(attr, (value, key) => {
		// Model?
		if (isModel(value)) {
			// Get snapshot and recursively remove mobx-keystone internal properties
			const snapshot = getSnapshot(value)
			attr[key] = cleanSnapshot(snapshot)
		}
	})

	// Make it up
	const result: ApiResource = {
		attributes: attr,
		type: resourceName,
	}
	if (id) result.id = id

	return result
}
